import { PlatformPayload } from "Types/App";
import { get, post, put, remove } from "../../ApiService";
import { SsoApiUrl } from "../../ApiUrl";

export const createVoyageControlPlatform = async (data: PlatformPayload) => {
  try {
    const res = await post(`${SsoApiUrl.platformsManagement.platforms}`, data);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getVoyageControlPlatforms = async (filters?: { order_by?: string }) => {
  try {
    const res = await get(`${SsoApiUrl.platformsManagement.platforms}`, {
      ...(filters?.order_by && { order_by: filters.order_by }),
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getVoyageControlPlatform = async (code: string) => {
  try {
    const res = await get(`${SsoApiUrl.platformsManagement.platform(code)}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const updateVoyageControlPlatform = async (
  code: string,
  data: PlatformPayload
) => {
  try {
    const res = await put(
      `${SsoApiUrl.platformsManagement.platform(code)}`,
      data
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const deleteVoyageControlPlatform = async (code: string) => {
  try {
    const res = await remove(`${SsoApiUrl.platformsManagement.platform(code)}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getRegionsList = async () => {
  try {
    const res = await get(SsoApiUrl.projectManagement.projectRegions);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getAccountManagerCount = async () => {
  try {
    const res = await get(`${SsoApiUrl.filterOptions.accountManagersCount}`);
    return res;
  } catch (error: any) {
    return error.response;
  }
};
export const getOrganizationProjectsCount = async () => {
  try {
    const res = await get(
      `${SsoApiUrl.filterOptions.organizationProjectsCount}`
    );
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const getProjectStatusCount = async () => {
  try {
    const res = await get(`${SsoApiUrl.filterOptions.projectStatusCount}`);
    return res;
  } catch (err: any) {
    return err.response;
  }
};

export const getProjectUsersCount = async () => {
  try {
    const res = await get(`${SsoApiUrl.filterOptions.projectUsersCount}`);
    return res;
  } catch (err: any) {
    return err.response;
  }
};

export const getUsersStatusCount = async () => {
  try {
    const res = await get(`${SsoApiUrl.filterOptions.usersStatusCount}`);
    return res;
  } catch (err: any) {
    return err.response;
  }
};

export const getOrganizationUsersCount = async () => {
  try {
    const res = await get(`${SsoApiUrl.filterOptions.organizationUsersCount}`);
    return res;
  } catch (err: any) {
    return err.response;
  }
};
